// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ArrowLeftOutlinedSvg from "@ant-design/icons-svg/es/asn/ArrowLeftOutlined";
import AntdIcon from '../components/AntdIcon';

var ArrowLeftOutlined = function ArrowLeftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ArrowLeftOutlinedSvg
  }));
};

ArrowLeftOutlined.displayName = 'ArrowLeftOutlined';
export default /*#__PURE__*/React.forwardRef(ArrowLeftOutlined);